export default __webpack_public_path__ + "static/media/home3.13b30d4a.svg";